<template>
  <div class="text-sm flex flex-col gap-1">
    <vs-row
      vs-w="12"
      v-for="(item, index) in fields"
      :key="index"
    >
      <vs-col vs-w="5">
        <span> {{ item.text }} </span>
      </vs-col>
      <vs-col
        vs-w="7"
        class="flex justify-end text-right"
        :class="{
          'text-primary': item.value !== 'last_activity',
          'text-secondary': item.value === 'last_activity',
        }"
      >
        <span v-if="item.text === 'Loaded Coal' && data.is_docking && !data.is_blu_available">N/A</span>
        <span v-else>
          {{
            item.isDate 
              ? moment(data[item.value]).format('DD MMM YYYY HH:mm:ss')
              : ['coal', 'plan_coal'].includes(item.value)
                ? handleValidateAndFormatNumber(data[item.value])
                : data[item.value] > -1 ? data[item.value] : data[item.value] || 'N/A'
          }}
        </span>
      </vs-col>
    </vs-row>
    <div>
      <span
        class="mt-2 w-full flex flex-row items-center justify-end font-semibold underline cursor-pointer"
        style="color: #56B9F2"
        @click="goToBLUList"
      >
        View BLU Detail
        <img :src="require('@/assets/shipo-icon-double-arrow-right.svg')">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Details',
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      fields: [
        {
          text: 'Last Activity',
          value: 'last_activity'
        },
        {
          text: 'Position Time',
          value: 'position_time',
          isDate: true
        },
        {
          text: 'Waypoint',
          value: 'way_point'
        },
        {
          text: 'Loaded Coal',
          value: 'coal'
        },
        {
          text: 'Planned Coal',
          value: 'plan_coal'
        },
        {
          text: 'Latitude',
          value: 'latitude'
        },
        {
          text: 'Longitude',
          value: 'longitude'
        },
        {
          text: 'Heading',
          value: 'heading'
        },
        {
          text: 'Speed',
          value: 'speed'
        },
        {
          text: 'Proximity',
          value: 'proximity'
        },
        {
          text: 'Route Name',
          value: 'route_name'
        },
        {
          text: 'Distance',
          value: 'distance'
        },
        {
          text: 'Company Name',
          value: 'company_name'
        },
        {
          text: 'Product',
          value: 'product'
        }
      ]
    }
  },
  methods: {
    goToBLUList() {
      this.$router.push({ name: 'BargeLineUpList', params: { blu_id: this.data?.blu_id }})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

